const ladyLoading = url => () => import(`../views/${url}.vue`)

// 租控管理
const Home = ladyLoading('Home/home')
const routes = {
  path: 'home',
  name: 'home',
  title: '首页',
  component: Home,
  children: [],
  meta: {
    closeable: false,
    hideInAdmin: false,
    menuId: 'contract004',
    type: 'menu',
    zhname: '首页',
    icon: 'rentcontrolfirstpage'
  }
}

export default routes



// WEBPACK FOOTER //
// ./src/area-contract/router/business.js